import React, {useRef, useState, useEffect} from 'react';
import {createPortal} from 'react-dom';

export function ModalReadyAnswersGlobal({open, trigger, onClose, handleOpen, children, isStatic, isEdit}) {
  const [active, setActive] = useState(false);
  const refTrigger = useRef(null);
  const refOverlay = useRef(null);

  useEffect(() => {
    if (typeof open !== 'undefined' && open !== active) {
      setActive(open);
    }
  }, [open, active]);

  const handleActive = (value) => {
    if (isStatic) {
      handleOpen(value);
      return;
    }
    setActive(value);
    if (!value && typeof onClose === 'function') {
      onClose();
    }
  };
  
  const handleTriggerClick = (e) => {
    if (!refTrigger || !refTrigger.current || !refTrigger.current.contains(e.target)) {
      return;
    }
    handleActive(true);
  };
  
  //const handleOutsideClick = (e) => {
    ///*sif (isStatic) {
      //return;
    //}*/
    //if (!refOverlay || !refOverlay.current || !refOverlay.current.contains(e.target) || (e.target.className != "main-popup__wrap")) {
      //return;
    //}
    //handleActive(false);
  //};

  return <React.Fragment>
    {!isEdit && <a className="ready-answers__top-action js-popup__btn" ref={refTrigger} onClick={handleTriggerClick}>Добавить</a>}
    {isEdit && <a className="ready-answers-item__action js-popup__btn" ref={refTrigger} onClick={handleTriggerClick}><svg><use xlinkHref="#edit"></use></svg></a>}
    {createPortal(
    <React.Fragment>
        {active && <div className={"main-popup js-popup" + (active ? " open" : "")}>
            <div className="main-popup__wrap" ref={refOverlay}>
                <div className="main-popup__body js-popup__body">
                    <div className="main-popup__close js-popup__close" onClick={() => handleActive(false)}>
                        <svg>
                            <use xlinkHref="#close"></use>
                        </svg>
                    </div>
                    {children}
                </div>
            </div>
        </div>}
    </React.Fragment>,
    document.body
    )}
    </React.Fragment>;
};
